import { handleActions } from 'redux-actions';

import { TERMS_ON_CHANGE } from '../constants';

const init = {
  acceptedProductIds: [],
  acceptedProductOptionIds: [],
};

export default handleActions(
  {
    [TERMS_ON_CHANGE]: (state, action) => ({
      ...state,
      acceptedProductOptionIds:
        state.acceptedProductOptionIds.find(productId =>
          action.payload.productOptionIds.includes(productId),
        ) !== undefined
          ? state.acceptedProductOptionIds.filter(productId =>
              action.payload.productOptionIds.find(p => p !== productId),
            )
          : [...state.acceptedProductOptionIds, ...action.payload.productOptionIds],
      acceptedProductIds: state.acceptedProductIds.includes(action.payload.productId)
        ? state.acceptedProductIds.filter(productId => productId !== action.payload.productId)
        : [...state.acceptedProductIds, action.payload.productId],
    }),
  },
  init,
);
